import { useMediaQuery } from "@mui/material";

import MobileView from "./Mobile";
import Web from "./Web";
export default function Home() {
    const isSmallScreen = useMediaQuery("(max-width:960px)");
    return <>{isSmallScreen ? <MobileView /> : <Web />}</>;
}
